import CookiesJS from 'cookies-js';
import { submitHandler } from './submit-handler';

/**
 * Окно «Настроить неделю».
 *
 * Человек листает варианты дня плана у каждого дня недели и сохраняет
 * раскладку. Варианты не пересобираются — меняется только то, какой
 * из них в какой день (bod-knowledge decisions/week-day-variants.md).
 *
 * Листается по кругу: вариантов столько, сколько собрал генератор,
 * и это не всегда семь — сборщик раскладывает по дням и три, и пять.
 */
export function initWeekSetup($, apiClient) {
    const $root = $('.week-setup');
    if (!$root.length) return;

    const variants = JSON.parse($root.attr('data-variants') || '[]');
    if (!variants.length) return;
    const userId = ($root.attr('data-user-id') || '').trim();

    // Незавершённая раскладка переживает уход на рецепт. Со снимка
    // человек уходит на страницу дня и возвращается сюда — сервер
    // отдаст ту раскладку, что в профиле, и всё наклацанное пропало
    // бы, хотя «Сохранить» он не нажимал.
    //
    // Храним в `sessionStorage`: это черновик одной вкладки, он не
    // должен ни пережить закрытие окна, ни уехать на другое
    // устройство. Снимается при сохранении и при закрытии крестиком.
    const DRAFT_KEY = `week-setup-draft:${userId}`;

    function readDraft() {
        try {
            const raw = window.sessionStorage.getItem(DRAFT_KEY);
            if (!raw) return null;
            const draft = JSON.parse(raw);
            // Варианты могли пересобраться, пока человек ходил:
            // тогда черновик уже не про эту неделю.
            const numbers = variants.map(variant => variant.number).join(',');
            return draft && draft.numbers === numbers ? draft.days : null;
        } catch (error) {
            return null;
        }
    }

    function writeDraft() {
        try {
            const days = {};
            $root.find('.week-setup__day').each(function () {
                days[$(this).attr('data-day-index')] = $(this).find('.week-stepper__value').text().trim();
            });
            window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify({
                numbers: variants.map(variant => variant.number).join(','),
                days,
            }));
        } catch (error) {
            // Приватный режим и запрет на хранилище — не повод ломать
            // страницу: черновика просто не будет.
        }
    }

    function forgetDraft() {
        try {
            window.sessionStorage.removeItem(DRAFT_KEY);
        } catch (error) {
            // см. выше
        }
    }

    function variantAt(index) {
        return variants[(index + variants.length) % variants.length];
    }

    function indexOfNumber(number) {
        const found = variants.findIndex(variant => variant.number === number);
        return found === -1 ? 0 : found;
    }

    function renderDay($day, variant) {
        $day.find('.week-stepper__value').text(variant.number);
        // Фотографии перерисовываем целиком: у разных вариантов
        // число приёмов пищи одно и то же, но снимки свои. Собираем
        // элементами, а не строкой разметки: название блюда приходит
        // из справочника и может содержать кавычки.
        const $meals = $day.find('.week-setup__meals').empty();
        for (const meal of variant.meals) {
            // Снимок ведёт на рецепт в дне своего варианта. У варианта,
            // оставшегося без дней недели, страницы дня нет — там
            // снимок не ссылка.
            const $meal = meal.href
                ? $('<a class="week-setup__meal"></a>').attr({ href: meal.href, 'aria-label': meal.title })
                : $('<div class="week-setup__meal"></div>');
            $meal
                .append($('<img>', {
                    src: meal.imageHref,
                    alt: meal.title,
                    loading: 'lazy',
                    decoding: 'async',
                }))
                .appendTo($meals);
        }
    }

    $root.on('click', '.week-stepper__btn', function () {
        const $day = $(this).closest('.week-setup__day');
        const step = parseInt($(this).attr('data-step'), 10);
        const current = parseInt($day.find('.week-stepper__value').text(), 10);
        renderDay($day, variantAt(indexOfNumber(current) + step));
        writeDraft();
    });

    // Крестик — это отказ от правок, а не пауза: черновик снимаем.
    $(document).on('click', '.close-button', forgetDraft);

    const draft = readDraft();
    if (draft) {
        $root.find('.week-setup__day').each(function () {
            const number = parseInt(draft[$(this).attr('data-day-index')], 10);
            if (!number) return;
            renderDay($(this), variantAt(indexOfNumber(number)));
        });
    }

    submitHandler('.action__week-setup', async function () {
        // Собираем обратную раскладку: вариант → его дни недели.
        // Варианты без дней тоже уходят на сервер, с пустым массивом:
        // иначе они пропадут из профиля, и человек не сможет вернуть
        // их обратно переключателем.
        const daysByNumber = {};
        for (const variant of variants) daysByNumber[variant.number] = [];
        $root.find('.week-setup__day').each(function () {
            const dayIndex = parseInt($(this).attr('data-day-index'), 10);
            const number = parseInt($(this).find('.week-stepper__value').text(), 10);
            if (!daysByNumber[number]) daysByNumber[number] = [];
            daysByNumber[number].push(dayIndex);
        });
        const programms = variants.map(variant => ({
            programmId: variant.programmId,
            weekDays: daysByNumber[variant.number],
        }));
        await apiClient.setUserProgramms(userId, programms, CookiesJS.get('auth_token'));
        forgetDraft();
        // Со страницы уходим на «Питание»: там человек и увидит, что
        // неделя сложилась, — ради этого он сюда и приходил.
        document.location.href = '/supply';
    });
}
